import React from 'react';
import { Link } from 'react-router-dom';
import { Header, Segment, List, Form, Button, Message } from 'semantic-ui-react';
import axios from 'axios';
import dealerValidation from './helpers/_profileValidation';
import { usStates } from '../../../common/_us_states';
import { timeZoneOptions } from '../../../common/_timeZoneOptions';

class ProfileEditForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      reqResponse: null,
      errors: {
        messages: [],
        fields: [],
      }
    };

    this.onSubmit = this.onSubmit.bind(this);
    this.handleEditChange = this.handleEditChange.bind(this);
  }

  handleEditChange(e, v) {
    const { errors } = this.state;
    const fieldName = e.target.name;

    let eventData = null;

    if (e.target.name) {
      eventData = {
        target: {
          name: e.target.name,
          value: e.target.value,
        }
      }
    } else {
      eventData = {
        target: {
          name: v.name,
          value: v.value,
        }
      }
    }

    this.props.handleEditChange(eventData);

    const newData = {
      address_1: this.props.address_1,
      address_2: this.props.address_2,
      city: this.props.city,
      name: this.props.name,
      country: this.props.country,
      email: this.props.email,
      id: this.props.id,
      phone: this.props.phone,
      state: this.props.state,
      zip: this.props.zip,
      time_zone: this.props.time_zone,
    };

    if (errors.fields.includes(fieldName)) {
      const validator = dealerValidation(newData, 'edit');
      this.setState({ errors: validator });
    }
  }

  onSubmit(e) {
    e.preventDefault();

    const { id } = this.props;
    const formData = {
      address_1: this.props.address_1,
      address_2: this.props.address_2,
      city: this.props.city,
      name: this.props.name,
      country: this.props.country,
      email: this.props.email,
      id: this.props.id,
      phone: this.props.phone,
      state: this.props.state,
      zip: this.props.zip,
      time_zone: this.props.time_zone,
    };

    const validation = dealerValidation(formData, 'edit');
    this.setState({ errors: validation });

    if (validation.messages.length === 0) {
      this.setState({ loading: true });

      axios.put(`/profile/`, formData)
        .then(res => {
          this.setState({
            loading: false,
            reqResponse: {
              header: 'Profile Updated!',
              success: true,
              content: `Your profile has been updated`
            }
          })
        })
        .then(() => {
          setTimeout(() => {
            this.setState({ reqResponse: null });
          }, 3000);
        })
        .catch(err => {
          this.setState({
            loading: false,
            reqResponse: {
              header: 'There was a problem',
              success: false,
              content: 'There was an issue saving your profile',
            }
          });

          setTimeout(() => {
            this.setState({
              reqResponse: null
            });
          }, 3000);
        });
    }
  }

  render() {

    const { loading, reqResponse, errors } = this.state;

    const {
      address_1,
      address_2,
      city,
      name,
      country,
      email,
      id,
      phone,
      state,
      zip,
      time_zone,
    } = this.props;

    const errorList = errors.messages.map(x => x.message);
    const invalidFields = errors.fields;
    let formError = false;

    if (errors.messages.length > 0) {
      formError = true;
    }

    return (
      <div>
        {
          reqResponse
            ? (
                <Message
                  header={reqResponse.header}
                  icon={reqResponse.success ? 'check' : 'exclamation'}
                  positive={reqResponse.success ? true : false}
                  error={!reqResponse.success ? true : false}
                  content={reqResponse.content}
                />
              )
            : null
        }
        <Form error={formError} loading={loading}>
          <Message
            error
            header="Problems"
            negative
            list={errorList}
          />
          <Form.Input
            label="Name"
            name="name"
            value={name}
            onChange={this.handleEditChange}
            error={invalidFields.includes('name')}
            required
          />
          <Form.Group widths="equal">
            <Form.Input
              label="Email"
              name="email"
              value={email}
              onChange={this.handleEditChange}
              error={invalidFields.includes('email')}
              required
            />
            <Form.Input
              label="Phone"
              name="phone"
              value={phone}
              onChange={this.handleEditChange}
              error={invalidFields.includes('phone')}
            />
          </Form.Group>
          <Form.Input
            label="Address Line 1"
            name="address_1"
            value={address_1}
            onChange={this.handleEditChange}
          />
          <Form.Input
            label="Address Line 2"
            name="address_2"
            value={address_2}
            onChange={this.handleEditChange}
          />
          <Form.Group widths="equal">
            <Form.Input
              label="City"
              name="city"
              value={city}
              onChange={this.handleEditChange}
            />
            <Form.Select
              placeholder="Select"
              name="state"
              label="State"
              search
              selection
              value={state}
              options={usStates}
              onChange={this.handleEditChange}
            />
            <Form.Input
              label="Zip"
              name="zip"
              value={zip}
              onChange={this.handleEditChange}
            />
          </Form.Group>
          <Form.Select
            placeholder="Select"
            name="time_zone"
            label="Time Zone"
            selection
            width={5}
            value={time_zone}
            options={timeZoneOptions}
            onChange={this.handleEditChange}
          />
          <Button positive content="Save" onClick={this.onSubmit} />
        </Form>
      </div>
    );
  }
}

export default ProfileEditForm;
